__turbopack_context__.v({
  "hidden": "RevealFx-module-scss-module__zc9giG__hidden",
  "revealFx": "RevealFx-module-scss-module__zc9giG__revealFx",
  "revealed": "RevealFx-module-scss-module__zc9giG__revealed",
});
